/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DefineWinnerServiceNegotiationRequest,
  EntitiesServiceNegotiationDetail,
  EntitiesServiceNegotiationDocumentListResponse,
  EntitiesServiceNegotiationListResponse,
  GetServiceNegotiationDocumentsParams,
  ListServiceNegotiationsParams,
  RejectServiceNegotiationRequest
} from '../../models';

import { customInstance } from '../../../../services/api';
import type { ErrorType } from '../../../../services/api';
import { customQueryOptions } from '../../../../mutators/customQueryOptions';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Show a service negotiation
 */
export const showServiceNegotiation = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceNegotiationDetail>(
      {url: `/api/v3/service_negotiations/${id}`, method: 'GET', signal
    },
      options);
    }




export const getShowServiceNegotiationInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/service_negotiations/${id}`
    ] as const;
    }

export const getShowServiceNegotiationQueryKey = (id: number,) => {
    return [
    `/api/v3/service_negotiations/${id}`
    ] as const;
    }


export const useShowServiceNegotiationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowServiceNegotiationInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showServiceNegotiation>>> = ({ signal }) => showServiceNegotiation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowServiceNegotiationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showServiceNegotiation>>>
export type ShowServiceNegotiationInfiniteQueryError = ErrorType<unknown>


export function useShowServiceNegotiationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showServiceNegotiation>>,
          TError,
          Awaited<ReturnType<typeof showServiceNegotiation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceNegotiationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showServiceNegotiation>>,
          TError,
          Awaited<ReturnType<typeof showServiceNegotiation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceNegotiationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show a service negotiation
 */

export function useShowServiceNegotiationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowServiceNegotiationInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show a service negotiation
 */
export const prefetchShowServiceNegotiationInfiniteQuery = async <TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowServiceNegotiationInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowServiceNegotiationInfinite} query
 */
export const invalidateShowServiceNegotiationInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowServiceNegotiationInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowServiceNegotiationQueryOptions = <TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowServiceNegotiationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showServiceNegotiation>>> = ({ signal }) => showServiceNegotiation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowServiceNegotiationQueryResult = NonNullable<Awaited<ReturnType<typeof showServiceNegotiation>>>
export type ShowServiceNegotiationQueryError = ErrorType<unknown>


export function useShowServiceNegotiation<TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showServiceNegotiation>>,
          TError,
          Awaited<ReturnType<typeof showServiceNegotiation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceNegotiation<TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showServiceNegotiation>>,
          TError,
          Awaited<ReturnType<typeof showServiceNegotiation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceNegotiation<TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show a service negotiation
 */

export function useShowServiceNegotiation<TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowServiceNegotiationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show a service negotiation
 */
export const prefetchShowServiceNegotiationQuery = async <TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowServiceNegotiationQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowServiceNegotiation} query
 */
export const invalidateShowServiceNegotiation = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowServiceNegotiationQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowServiceNegotiationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowServiceNegotiationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showServiceNegotiation>>> = ({ signal }) => showServiceNegotiation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowServiceNegotiationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof showServiceNegotiation>>>
export type ShowServiceNegotiationSuspenseQueryError = ErrorType<unknown>


export function useShowServiceNegotiationSuspense<TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceNegotiationSuspense<TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceNegotiationSuspense<TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show a service negotiation
 */

export function useShowServiceNegotiationSuspense<TData = Awaited<ReturnType<typeof showServiceNegotiation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowServiceNegotiationSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useShowServiceNegotiationSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowServiceNegotiationInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showServiceNegotiation>>> = ({ signal }) => showServiceNegotiation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowServiceNegotiationSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showServiceNegotiation>>>
export type ShowServiceNegotiationSuspenseInfiniteQueryError = ErrorType<unknown>


export function useShowServiceNegotiationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceNegotiationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceNegotiationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show a service negotiation
 */

export function useShowServiceNegotiationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceNegotiation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceNegotiation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowServiceNegotiationSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List service negotiation documents
 */
export const getServiceNegotiationDocuments = (
    id: number,
    params?: GetServiceNegotiationDocumentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceNegotiationDocumentListResponse>(
      {url: `/api/v3/service_negotiations/${id}/documents`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetServiceNegotiationDocumentsInfiniteQueryKey = (id: number,
    params?: GetServiceNegotiationDocumentsParams,) => {
    return [
    'infinite', `/api/v3/service_negotiations/${id}/documents`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetServiceNegotiationDocumentsQueryKey = (id: number,
    params?: GetServiceNegotiationDocumentsParams,) => {
    return [
    `/api/v3/service_negotiations/${id}/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetServiceNegotiationDocumentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceNegotiationDocumentsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>> = ({ signal }) => getServiceNegotiationDocuments(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceNegotiationDocumentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>
export type GetServiceNegotiationDocumentsInfiniteQueryError = ErrorType<unknown>


export function useGetServiceNegotiationDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetServiceNegotiationDocumentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceNegotiationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getServiceNegotiationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceNegotiationDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceNegotiationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getServiceNegotiationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceNegotiationDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service negotiation documents
 */

export function useGetServiceNegotiationDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceNegotiationDocumentsInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List service negotiation documents
 */
export const prefetchGetServiceNegotiationDocumentsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetServiceNegotiationDocumentsInfiniteQueryOptions(id,params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetServiceNegotiationDocumentsInfinite} query
 */
export const invalidateGetServiceNegotiationDocumentsInfinite = async (
 queryClient: QueryClient, id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetServiceNegotiationDocumentsInfiniteQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useGetServiceNegotiationDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceNegotiationDocumentsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>> = ({ signal }) => getServiceNegotiationDocuments(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceNegotiationDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>
export type GetServiceNegotiationDocumentsQueryError = ErrorType<unknown>


export function useGetServiceNegotiationDocuments<TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetServiceNegotiationDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceNegotiationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getServiceNegotiationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceNegotiationDocuments<TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceNegotiationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getServiceNegotiationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceNegotiationDocuments<TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service negotiation documents
 */

export function useGetServiceNegotiationDocuments<TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceNegotiationDocumentsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List service negotiation documents
 */
export const prefetchGetServiceNegotiationDocumentsQuery = async <TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetServiceNegotiationDocumentsQueryOptions(id,params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetServiceNegotiationDocuments} query
 */
export const invalidateGetServiceNegotiationDocuments = async (
 queryClient: QueryClient, id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetServiceNegotiationDocumentsQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useGetServiceNegotiationDocumentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceNegotiationDocumentsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>> = ({ signal }) => getServiceNegotiationDocuments(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceNegotiationDocumentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>
export type GetServiceNegotiationDocumentsSuspenseQueryError = ErrorType<unknown>


export function useGetServiceNegotiationDocumentsSuspense<TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetServiceNegotiationDocumentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceNegotiationDocumentsSuspense<TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceNegotiationDocumentsSuspense<TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service negotiation documents
 */

export function useGetServiceNegotiationDocumentsSuspense<TData = Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceNegotiationDocumentsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetServiceNegotiationDocumentsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceNegotiationDocumentsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>> = ({ signal }) => getServiceNegotiationDocuments(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceNegotiationDocumentsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>
export type GetServiceNegotiationDocumentsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetServiceNegotiationDocumentsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetServiceNegotiationDocumentsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceNegotiationDocumentsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceNegotiationDocumentsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service negotiation documents
 */

export function useGetServiceNegotiationDocumentsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetServiceNegotiationDocumentsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceNegotiationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceNegotiationDocumentsSuspenseInfiniteQueryOptions(id,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Reject a service negotiation
 */
export const rejectServiceNegotiation = (
    id: number,
    rejectServiceNegotiationRequest?: RejectServiceNegotiationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceNegotiationDetail>(
      {url: `/api/v3/service_negotiations/${id}/reject`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rejectServiceNegotiationRequest, signal
    },
      options);
    }




export const getRejectServiceNegotiationMutationKey = () => ['rejectServiceNegotiation'] as const;

export const getRejectServiceNegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectServiceNegotiation>>, TError,RejectServiceNegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectServiceNegotiation>>, TError,RejectServiceNegotiationMutationVariables, TContext> => {

const mutationKey = getRejectServiceNegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectServiceNegotiation>>, RejectServiceNegotiationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  rejectServiceNegotiation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectServiceNegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectServiceNegotiation>>>
    export type RejectServiceNegotiationMutationBody = RejectServiceNegotiationRequest | undefined
    export type RejectServiceNegotiationMutationError = ErrorType<unknown>
    export type RejectServiceNegotiationMutationVariables = {id: number;data?: RejectServiceNegotiationRequest}

    /**
 * @summary Reject a service negotiation
 */
export const useRejectServiceNegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectServiceNegotiation>>, TError,RejectServiceNegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectServiceNegotiation>>,
        TError,
        RejectServiceNegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getRejectServiceNegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary Revert rejection of a service negotiation
 */
export const revertRejectServiceNegotiation = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceNegotiationDetail>(
      {url: `/api/v3/service_negotiations/${id}/revert_reject`, method: 'PUT', signal
    },
      options);
    }




export const getRevertRejectServiceNegotiationMutationKey = () => ['revertRejectServiceNegotiation'] as const;

export const getRevertRejectServiceNegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revertRejectServiceNegotiation>>, TError,RevertRejectServiceNegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revertRejectServiceNegotiation>>, TError,RevertRejectServiceNegotiationMutationVariables, TContext> => {

const mutationKey = getRevertRejectServiceNegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revertRejectServiceNegotiation>>, RevertRejectServiceNegotiationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  revertRejectServiceNegotiation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevertRejectServiceNegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof revertRejectServiceNegotiation>>>

    export type RevertRejectServiceNegotiationMutationError = ErrorType<unknown>
    export type RevertRejectServiceNegotiationMutationVariables = {id: number}

    /**
 * @summary Revert rejection of a service negotiation
 */
export const useRevertRejectServiceNegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revertRejectServiceNegotiation>>, TError,RevertRejectServiceNegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revertRejectServiceNegotiation>>,
        TError,
        RevertRejectServiceNegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getRevertRejectServiceNegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary Define winner for a service negotiation
 */
export const defineWinnerServiceNegotiation = (
    id: number,
    defineWinnerServiceNegotiationRequest: DefineWinnerServiceNegotiationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceNegotiationDetail>(
      {url: `/api/v3/service_negotiations/${id}/define_winner`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: defineWinnerServiceNegotiationRequest, signal
    },
      options);
    }




export const getDefineWinnerServiceNegotiationMutationKey = () => ['defineWinnerServiceNegotiation'] as const;

export const getDefineWinnerServiceNegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineWinnerServiceNegotiation>>, TError,DefineWinnerServiceNegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof defineWinnerServiceNegotiation>>, TError,DefineWinnerServiceNegotiationMutationVariables, TContext> => {

const mutationKey = getDefineWinnerServiceNegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof defineWinnerServiceNegotiation>>, DefineWinnerServiceNegotiationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  defineWinnerServiceNegotiation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DefineWinnerServiceNegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof defineWinnerServiceNegotiation>>>
    export type DefineWinnerServiceNegotiationMutationBody = DefineWinnerServiceNegotiationRequest
    export type DefineWinnerServiceNegotiationMutationError = ErrorType<unknown>
    export type DefineWinnerServiceNegotiationMutationVariables = {id: number;data: DefineWinnerServiceNegotiationRequest}

    /**
 * @summary Define winner for a service negotiation
 */
export const useDefineWinnerServiceNegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineWinnerServiceNegotiation>>, TError,DefineWinnerServiceNegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof defineWinnerServiceNegotiation>>,
        TError,
        DefineWinnerServiceNegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getDefineWinnerServiceNegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary List service negotiations
 */
export const listServiceNegotiations = (
    params?: ListServiceNegotiationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceNegotiationListResponse>(
      {url: `/api/v3/service_negotiations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListServiceNegotiationsInfiniteQueryKey = (params?: ListServiceNegotiationsParams,) => {
    return [
    'infinite', `/api/v3/service_negotiations`, ...(params ? [params] : [])
    ] as const;
    }

export const getListServiceNegotiationsQueryKey = (params?: ListServiceNegotiationsParams,) => {
    return [
    `/api/v3/service_negotiations`, ...(params ? [params] : [])
    ] as const;
    }


export const useListServiceNegotiationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceNegotiationsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceNegotiations>>> = ({ signal }) => listServiceNegotiations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceNegotiationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceNegotiations>>>
export type ListServiceNegotiationsInfiniteQueryError = ErrorType<unknown>


export function useListServiceNegotiationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceNegotiationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceNegotiations>>,
          TError,
          Awaited<ReturnType<typeof listServiceNegotiations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceNegotiationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceNegotiations>>,
          TError,
          Awaited<ReturnType<typeof listServiceNegotiations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceNegotiationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service negotiations
 */

export function useListServiceNegotiationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceNegotiationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List service negotiations
 */
export const prefetchListServiceNegotiationsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListServiceNegotiationsInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListServiceNegotiationsInfinite} query
 */
export const invalidateListServiceNegotiationsInfinite = async (
 queryClient: QueryClient, params?: ListServiceNegotiationsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListServiceNegotiationsInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListServiceNegotiationsQueryOptions = <TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceNegotiationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceNegotiations>>> = ({ signal }) => listServiceNegotiations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceNegotiationsQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceNegotiations>>>
export type ListServiceNegotiationsQueryError = ErrorType<unknown>


export function useListServiceNegotiations<TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceNegotiationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceNegotiations>>,
          TError,
          Awaited<ReturnType<typeof listServiceNegotiations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceNegotiations<TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceNegotiations>>,
          TError,
          Awaited<ReturnType<typeof listServiceNegotiations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceNegotiations<TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service negotiations
 */

export function useListServiceNegotiations<TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceNegotiationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List service negotiations
 */
export const prefetchListServiceNegotiationsQuery = async <TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListServiceNegotiationsQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListServiceNegotiations} query
 */
export const invalidateListServiceNegotiations = async (
 queryClient: QueryClient, params?: ListServiceNegotiationsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListServiceNegotiationsQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListServiceNegotiationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceNegotiationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceNegotiations>>> = ({ signal }) => listServiceNegotiations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceNegotiationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceNegotiations>>>
export type ListServiceNegotiationsSuspenseQueryError = ErrorType<unknown>


export function useListServiceNegotiationsSuspense<TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceNegotiationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceNegotiationsSuspense<TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceNegotiationsSuspense<TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service negotiations
 */

export function useListServiceNegotiationsSuspense<TData = Awaited<ReturnType<typeof listServiceNegotiations>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceNegotiationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListServiceNegotiationsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceNegotiationsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceNegotiations>>> = ({ signal }) => listServiceNegotiations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceNegotiationsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceNegotiations>>>
export type ListServiceNegotiationsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListServiceNegotiationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceNegotiationsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceNegotiationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceNegotiationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service negotiations
 */

export function useListServiceNegotiationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceNegotiations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceNegotiationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceNegotiations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceNegotiationsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






